module.exports = __webpack_public_path__ + "static/media/github.ab98cce9.svg";